/**
 * Meta(페이스북/인스타그램) 픽셀
 * - PIXEL_ID 발급 후 아래 상수만 교체하면 활성화됨 (빈 값이면 아무 동작 안 함)
 * - 운영 도메인에서만 동작 (dev 트래픽이 광고 학습 데이터를 오염시키지 않도록)
 */
const PIXEL_ID = '2306378409769067';

const PROD_HOSTS = ['shop3.io', 'www.shop3.io'];

declare global {
    interface Window {
        fbq?: (...args: unknown[]) => void;
        _fbq?: unknown;
    }
}

export function initMetaPixel() {
    if (!PIXEL_ID) return;
    if (!PROD_HOSTS.includes(window.location.hostname)) return;
    if (window.fbq) return;

    const fbq: any = (...args: unknown[]) => {
        fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
}

/** 표준 이벤트 전송 (예: Lead, Purchase, ViewContent) */
export function trackMetaPixel(event: string, params?: Record<string, unknown>) {
    if (window.fbq) {
        window.fbq('track', event, params);
    }
}
